const sample = list => {
  if (!Array.isArray(list)) {
    throw new Error('Expected argument to be an array');
  }

  if (!list || list.length === 0) {
    return null;
  }

  const sampledIndex = Math.floor(Math.random() * list.length);
  return list[sampledIndex];
};

export default sample;
